import { BadgeTextProps } from './badge.interface';
import * as S from './badge.styles';

const BadgeText = ({ color, children, className = '' }: BadgeTextProps) => (
  <S.BadgeText $statusColor={color} className={className}>
    {children}
  </S.BadgeText>
);

export default BadgeText;
